import { IRootStore } from '../../store/rootStore';
import { ListEntityType } from '../../lists';
import { IActionHandleListParams } from '../ActionHandleListBasic';
import {
  normalizeCommonFields,
  createActualBlockName,
  ActualNameCreator
} from '../common';

import { ActionRemoveFromListNormalizer } from './client';

const createActionRemoveUserFromListActualNameBase = ({
  listId,
  rootStore
}: {
  rootStore: IRootStore;
  listId: string | null;
}): string => {
  if (!listId) {
    return '';
  }
  const list = rootStore.listsStore.getList({
    lType: ListEntityType.users
  });
  const entity = list.entities[listId];
  return entity ? `Удалить из списка «${entity.title}»` : '';
};

export const createActionRemoveUserFromListActualName: ActualNameCreator<
  IActionHandleListParams
> = ({ params, rootStore }) =>
  createActionRemoveUserFromListActualNameBase({
    rootStore,
    listId: params.listId
  });

export const normalizeActionRemoveFromList: ActionRemoveFromListNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionRemoveUserFromListActualNameBase({
          rootStore: stores.rootStore,
          listId: raw.params.list_id
        }),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
